import { ca } from '@cian/analytics';
import { createLabel, createNewbuildingProduct } from '../../utils';
import { TViewMode } from '../ProjectsOnMap/ProjectsOnMap';
import { INewBuilding } from '../../types/newBuldings';

interface ITrackMapPinClickArguments {
  position: number;
  developerId: number;
  pinType: TViewMode;
  newbuilding: INewBuilding;
  regionId: number;
}

const el: Record<TViewMode, string> = {
  newBuildings: 'JK',
  offices: 'sales_office',
};

export function trackMapPinClick({
  newbuilding,
  regionId,
  position,
  developerId,
  pinType,
}: ITrackMapPinClickArguments) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_pin',
    label: el[pinType],
    products: [
      createNewbuildingProduct({
        id: newbuilding.id,
        isKpn: newbuilding.isKpn,
        isReliable: newbuilding.isReliable,
        name: newbuilding.title,
        regionId,
        position,
        developerId: [developerId],
        extra: { from_object: developerId },
      }),
    ],
  });
}

interface ITrackShowPhoneBalloonArguments {
  position: number;
  developerId: number;
  newbuilding: INewBuilding;
  regionId: number;
}

export function trackShowPhoneBalloon({
  newbuilding,
  regionId,
  position,
  developerId,
}: ITrackShowPhoneBalloonArguments) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_card_builder_map_block',
    label: createLabel(developerId),
    products: [
      createNewbuildingProduct({
        id: newbuilding.id,
        isKpn: newbuilding.isKpn,
        isReliable: newbuilding.isReliable,
        name: newbuilding.title,
        regionId,
        position,
        developerId: [developerId],
        extra: { from_object: developerId },
      }),
    ],
  });
}

interface ITrackSeeAllClickArguments {
  position: number;
  developerId: number;
  newbuilding: INewBuilding;
  regionId: number;
}

export function trackSeeAllClick({ newbuilding, regionId, position, developerId }: ITrackSeeAllClickArguments) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_map_pin',
    label: 'JK_flatsale',
    products: [
      createNewbuildingProduct({
        id: newbuilding.id,
        isKpn: newbuilding.isKpn,
        isReliable: newbuilding.isReliable,
        name: newbuilding.title,
        regionId,
        position,
        developerId: [developerId],
        extra: { from_object: developerId },
      }),
    ],
  });
}
